import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  profilesCache: {
    data: [],
    removedProfiles: [],
    timestamp: null,
    params: null
  },
  swipeStats: {
    dailySwipes: 0,
    lastSwipeDate: null
  }
};

const cacheSlice = createSlice({
  name: 'cache',
  initialState,
  reducers: {
    setCachedProfiles: (state, action) => {
      state.profilesCache = {
        ...state.profilesCache,
        data: action.payload.profiles,
        params: action.payload.params,
        timestamp: Date.now()
      };
    },
    updateCachedRemovedProfiles: (state, action) => {
      // Garder uniquement les 10 derniers profils supprimés
      const removedProfiles = action.payload.slice(0, 10);
      state.profilesCache = {
        ...state.profilesCache,
        removedProfiles
      };
    },
    clearProfilesCache: (state) => {
      state.profilesCache = initialState.profilesCache;
    },
    clearCache: (state) => {
      state.profilesCache = initialState.profilesCache;
      state.swipeStats = initialState.swipeStats;
    },
    setSwipeStats: (state, action) => {
      state.swipeStats = action.payload;
    },
    updateSwipeStats: (state, action) => {
      const today = new Date().toISOString().split('T')[0];
      const { lastSwipeDate } = state.swipeStats;
      
      // Si c'est un nouveau jour, réinitialiser le compteur
      if (lastSwipeDate !== today) {
        state.swipeStats = {
          dailySwipes: 1,
          lastSwipeDate: today
        };
      } else {
        // Sinon, incrémenter le compteur
        state.swipeStats.dailySwipes += 1;
      }
    },
    resetSwipeStats: (state) => {
      state.swipeStats = initialState.swipeStats;
    }
  }
});

export const {
  setCachedProfiles,
  updateCachedRemovedProfiles,
  clearProfilesCache,
  clearCache,
  updateSwipeStats,
  resetSwipeStats,
  setSwipeStats
} = cacheSlice.actions;

export default cacheSlice.reducer;
